import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import Payment from "./Payment";
import Sales from "./Sales";

export default function SalesManagement() {
  const menu = [
    {
      id: "payment",
      name: "Payment",
      icon: "fa-regular fa-credit-card",
      selected: true,
    },
    {
      id: "sales",
      name: "Sales",
      icon: "fa-solid fa-bars-progress",
    },
  ];

  const [menuDataSource, setMenuDataSource] = useState(menu);
  const [cMenu, setCMenu] = useState("payment");

  //   useEffect(() => {
  //     setMenuDataSource(menu);
  //   }, []);

  const handleClickMenu = (id) => {
    setMenuDataSource(
      menuDataSource.map((menu) => ({
        ...menu,
        selected: menu.id == id ? true : false,
      }))
    );

    setCMenu(id);
  };

  return (
    <React.Fragment>
      <Header
        title={"SALES MANAGEMENT"}
        menuDataSource={menuDataSource}
        setCMenu={setCMenu}
      />
      <div style={{ margin: "40px auto", width: "95vw" }}>
        {cMenu == "payment" ? (
          <Payment handleClickMenu={handleClickMenu} />
        ) : (
          <Sales />
        )}
      </div>
    </React.Fragment>
  );
}
